import { Box, Button, Divider, Grid, Typography } from "@mui/material";
import { OrganizationUserContext } from "contexts/Organization";
import {
  EMAIL_CREDIT_ROLLOVER_CAP_VA,
  EMAIL_CREDIT_ROLLOVER_MONTHLY_VA,
  SubscriptionContext,
} from "contexts/Subscription";
import { useContext } from "react";
import { BannerCouponName } from "schemas/dashboard";
import { Plans } from "schemas/payments";

import { useCheckout } from "components/StripeCheckout/useCheckout";
import { useSubscription } from "utils/useSubscription";

import styles from "../PlanCard/styles";
import PlansPrice from "../SharedComponents/Price";
import TermsAndConditions from "../SharedComponents/TermsAndConditions";
import {
  PlanAction,
  getB2GOEffectivePlan,
  getCurrentPlanButton,
} from "../helpers";

const MobilePlanCardVirtualAssistant = () => {
  const { onPlanButtonClick } = useSubscription();
  const { currentOrg } = useContext(OrganizationUserContext);
  const pricePlan = getB2GOEffectivePlan(Plans.VA, currentOrg?.isPaidUser);
  const { subscription, isAtEmailCreditCap } = useContext(SubscriptionContext);
  const action = getCurrentPlanButton(
    Plans.VA,
    subscription?.subscription?.planName || Plans.FREE,
    subscription,
  );
  const { getPromoCodeForPlan } = useCheckout();
  const promoCode = getPromoCodeForPlan(Plans.VA);
  const isMbg =
    promoCode && promoCode.couponName === BannerCouponName.money_back_guarantee;

  return (
    <Box sx={{ backgroundColor: "white", borderRadius: 3, mt: 1 }}>
      <Grid container justifyContent={"flex-end"} sx={{ pr: 1, pt: 1 }}>
        <Box
          sx={{
            backgroundColor: "purple.main",
            borderRadius: 6,
            px: 2,
            py: 0.5,
            fontSize: 11,
            mb: 2,
            fontWeight: 600,
          }}
        >
          {isMbg ? "Money-Back Guarantee" : "33x more likely to land a deal"}
        </Box>
      </Grid>

      <Box sx={{ px: 3, pb: 3 }}>
        <Grid container justifyContent="space-between" alignItems="flex-end">
          <Typography variant="h4" sx={{ fontSize: 26 }}>
            AI Virtual <br />
            Assistant
          </Typography>
          <PlansPrice plan={pricePlan} />
        </Grid>

        <Divider sx={{ my: 1, backgroundColor: "black" }} />

        {!isAtEmailCreditCap && (
          <Box sx={{ ...styles.rolloverInfoBox, mt: 2 }}>
            <Box sx={styles.rolloverInfoHeader}>
              <Box
                component="i"
                className="fa-solid fa-arrow-trend-up"
                sx={styles.rolloverInfoIcon}
              />
              <Typography sx={styles.rolloverInfoTitle}>
                Rollover Credits
              </Typography>
            </Box>
            <Typography sx={styles.rolloverInfoDesc}>
              {`Up to ${EMAIL_CREDIT_ROLLOVER_MONTHLY_VA} unused emails roll over monthly. Build up to a max of ${EMAIL_CREDIT_ROLLOVER_CAP_VA.toLocaleString()} total emails.`}
            </Typography>
          </Box>
        )}

        <Typography>
          <strong>Includes everything in Pro, plus:</strong>
        </Typography>

        <Typography sx={{ fontSize: 14, lineHeight: 2 }}>
          ⚡ 300 automated pitches send per month (+ 700 self serve emails)
          <br />
          💸 Exclusive brand pay data <br />
          🔐 600k+ brand contacts <br />
        </Typography>

        {!currentOrg?.overridePlanName && (
          <Button
            disableElevation
            fullWidth
            variant={action === PlanAction.upgrade ? "contained" : "text"}
            sx={{
              fontSize: 16,
              mt: 2,
              py: 1,
              borderRadius: 2,
              backgroundColor:
                action === PlanAction.upgrade ? "black" : "#f4f8f6",
            }}
            onClick={() => onPlanButtonClick(Plans.VA, action)}
          >
            Upgrade to AI Assistant
          </Button>
        )}

        <Grid container justifyContent={"center"} sx={{ mt: 1 }}>
          <TermsAndConditions plan={pricePlan} />
        </Grid>
      </Box>
    </Box>
  );
};

export default MobilePlanCardVirtualAssistant;
